<!-- A11Y-350: ajustes de accesibilidad -->
<div class="max-size-form">
  <button
    type="button"
    class="modal__close"
    (click)="hide.emit()"
    [attr.aria-label]="'Accessibility.aria_close' | translate"
    #primaryActionButton
  >
    <span class="ico-close" aria-hidden="true"></span>
  </button>
  <span class="modal__icon" [ngClass]="icon" aria-hidden="true"></span>
  <h2 *ngIf="head" class="modal__title" id="info-modal-title" tabindex="-1" #modalTitle>{{ head | translate }}</h2>
  <div class="modal__text">
    <div [innerHTML]="description | translate"></div>
  </div>
  <div *ngIf="hasCancelBtn" class="modal__double-btn">
    <button type="button" class="btn--secondary modal__btn" (click)="hide.emit()">
      {{ "Generic.cancel_button" | translate }}
    </button>
    <button type="button"  class="btn--primary modal__btn modal__btn-primary-focus" (click)="emitCallback()">
      {{ "Generic.accept_button" | translate }}
    </button>
  </div>
<button *ngIf="!hasCancelBtn" type="button"  class="btn--primary modal__btn modal__btn-primary-focus" (click)="hide.emit()">
  {{ confirmText | translate }}
</button>
</div>
